import { BaseApi } from './base-api';
import { IResponsePadrao } from '../types/response-padrao';

export interface CompraReembolsavel {
  id: string;
  nomeProduto: string;
  valorPago: number;
  dataCompra: string;
  emailComprador: string;
  nomeComprador: string;
  diasGarantia: number;
  garantiaExpirada: boolean;
  dataLimiteGarantia: string;
  nomeVendedor: string;
}

export interface ReembolsoResponse {
  id: string;
  vendaId: string;
  solicitanteId: string;
  motivo: number;
  descricao?: string;
  status: number;
  dataSolicitacao: string;
}

export class ReembolsoApi extends BaseApi<any> {
  constructor() {
    super('reembolso');
  }

  async buscarCompras(
    email: string,
    recaptchaToken: string,
  ): Promise<IResponsePadrao<CompraReembolsavel[]>> {
    const params = new URLSearchParams({
      email,
      recaptchaToken,
    });
    return (await this.api.get(`${this.path}/buscar-compras?${params.toString()}`)).data;
  }

  async enviarCodigo(
    vendaId: string,
    email: string,
    recaptchaToken: string,
  ): Promise<IResponsePadrao<{ enviado: boolean }>> {
    return (
      await this.api.post(`${this.path}/enviar-codigo`, {
        vendaId,
        email,
        recaptchaToken,
      })
    ).data;
  }

  async confirmarCodigo(
    vendaId: string,
    codigo: string,
    recaptchaToken: string,
    motivo?: number,
    descricao?: string,
  ): Promise<IResponsePadrao<ReembolsoResponse>> {
    return (
      await this.api.post(`${this.path}/confirmar-codigo`, {
        vendaId,
        codigo,
        motivo,
        descricao,
        recaptchaToken,
      })
    ).data;
  }
}
